// Asset detail page (CHG-1234 / ITER-3357).
//
// Thin per the v6 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates assetDetailConfig from asset.entity-hint.yaml
// without touching this file.
//
// Spec: specs/tier-05-experience/asset-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { assetDetailConfig } from "../generated/screens/asset-detail";

export function AssetDetail() {
  return <DetailPage config={assetDetailConfig} />;
}
